<template>
  <div class="backgroundClass">
    <div class="loginBox">
      <!-- Login -->
      <img class="logo-wrap" src="/static/LogoTest.png" alt="Mountain View">
      <input v-model="name" placeholder="Fornavn" type="text" >
      <div v-if="errorMsgName" class="errorMsg">
        {{errorMsgName}}
      </div>

      <input v-model="email" placeholder="E-mail" type="email" >
      <div v-if="errorMsgEmail" class="errorMsg">
        {{errorMsgEmail}}
      </div>

      <input v-model="password" placeholder="Password" type="password">
      <div v-if="errorMsgPassword" class="errorMsg">
        {{errorMsgPassword}}
      </div>

      <input v-model="rePassword" placeholder="Retype Password" type="password">
      <div v-if="errorMsgRePassword" class="errorMsg">
        {{errorMsgRePassword}}
      </div>

      <input v-model="laundryRoom" placeholder="VaskerumsID" type="text" />
      <div v-if="errorMsgLaundryRoom" class="errorMsg">
        {{errorMsgLaundryRoom}}
      </div>

      <button v-on:click="createUser">Opret bruger</button>
      <router-link class="loginLink" to="/login">Cancel</router-link>

    </div>
  </div>
</template>

<script>
import { app } from '@/firebase'
import { db } from '@/firebase'
import bus from '@/bus.js'
export default {
  data () {
    return {
      name: '',
      email: '',
      password: '',
      rePassword: '',
      laundryRoom: '',
      errorMsgLaundryRoom: '', //Forkert vaskerums id
      errorMsgPassword: '', //Koden er ikke stærk nok
      errorMsgRePassword: '', //Kodeord er ikke ens
      errorMsgEmail: '', //Ugyldig E-mail
      errorMsgName: '',
      testEmiter: false
    }
  },
  methods: {
    createUser: function() {
      if (this.name.length < 2) {
        this.errorMsgName = 'Venligst indtast et fornavn'
        return
      }
      if (this.laundryRoom.length <= 1) {
        this.errorMsgLaundryRoom = 'Forkert vaskerums id'
        return
      }

      if (this.password != this.rePassword) {
        this.errorMsgRePassword = 'Kodeord er ikke ens'
        return
      }
      var self = this
      db.ref('/list/').child(this.laundryRoom).once('value').then(function(snapshot) {
        if (snapshot.exists()) {

          app.auth().createUserWithEmailAndPassword(self.email, self.password).then(

          function(user) {
            const activeUser = app.auth().currentUser.uid;
            db.ref('users/' + activeUser).set({laundryroom: self.laundryRoom, name: self.name}).then(function(){
              // window.location.replace("http://atlantis.vaskerum.dk/") //Remember to change it to app.vaskerum.dk
              window.location.replace("http://app.vaskerum.dk/")
              // app.auth().signOut().then(() => {
              //   self.testEmiter = true
              // })
            })
          },
          function(error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            // console.log(errorCode + errorMessage);
            if (errorCode == 'auth/weak-password') {
              self.errorMsgPassword = 'Koden er ikke lang nok minimum 6 tegn'
            } else if (errorCode == 'auth/email-already-in-use') {
              self.errorMsgEmail = 'E-mailen er allerede i brug'
            } else if (errorCode = 'auth/invalid-email') {
              self.errorMsgEmail = 'Ugyldig email'
            }

            // alert('User not created!')
          });

          // alert('Room exists!')
        } else {
          self.errorMsgLaundryRoom = 'Forkert vaskerums id'
          // alert('Room dosent exists!')
        }
      });
    }
  },
  watch: {
    name: function () {
      if (this.name.length >= 2 )
      {this.errorMsgName = ''}
    },
    password: function () {
      if (this.password.length >= 6 )
      {this.errorMsgPassword = ''}
    },
    rePassword: function () {
      if (this.password == this.rePassword )
        {this.errorMsgRePassword = ''}
    },
    laundryRoom: function () {
      if (this.laundryRoom.length >= 1 )
      {this.errorMsgLaundryRoom = ''}
    },
    email: function () {
      this.errorMsgEmail = ''
    },
    testEmiter: function () {
      if (this.testEmiter) {
        alert('Du kan nu login ind med din bruger')
        bus.$emit('usercreated', 'ready')
        this.$router.replace('login')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}

.backgroundClass {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00BAE0;
  background: linear-gradient(rgba(0, 186, 224, 1), rgba(0, 186, 224, 0.5));
}

.loginBox {
  border-radius: 4px;
  width: 300px;
  height: 450px;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
}

.loginLink {
  position: absolute;
  bottom: 5px;
  right: 5px;
  text-decoration: none;
  /* color: rgba(0, 0, 0, 0.3); */
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
}

.errorMsg {
  color: rgba(223,77,80,0.9);
  text-align: left;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  cursor: pointer;
  /* color: #00BAE0; */
  color: rgba(0, 0, 0, 0.6);
  border: 0;
  /* font-size: 20px; */
  font-weight: 400;
  background: white;
  border-radius: 4px;
  /* box-shadow: 3px 3px 2px 0px rgba(0, 0, 0, 0.3); */
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.3);
  /* Flat design shadow */
}

input {
  margin: 6px 0;
  width: 100%;
  background-color: white;
  /* border: 1px solid #e8e7e3; */
  border: 0px;
  border-radius: 4px;
  /* color: #66615b; */
  font-size: 16px;
  padding: 7px 18px;
  height: 40px;
}
/* kg.hansen@gmail.com */
input:focus {
  outline: none;
}

.logo-wrap {
  display: block;
  width: 100%;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/register.vue